import { useMemo } from 'react';

import { useConfig } from '@shared/contexts/ConfigContext';

export const useAvailabilityScheduleConfig = (investment: boolean) => {
  const { availabilityScheduleConfig } = useConfig();

  return useMemo(
    () => ({
      availabilityScheduleConfig: investment ? availabilityScheduleConfig.investment : availabilityScheduleConfig.lease,
    }),
    [availabilityScheduleConfig, investment]
  );
};
